export const getPadding = (ratio) => `${(100 / ratio).toFixed(2)}%`;
